import { MutableRefObject, useState } from 'react';
import styled from 'styled-components';
import { marketPricePageInfo } from '../../../../constants/pageInfo/pageInfo.constant';
import { ampli } from '../../../../ampli';
import { useNavigate } from 'react-router-dom';
import { isIOS } from 'react-device-detect';
import { NakedInput } from '../../inputs/NakedInput';
import { IconButton } from '../../buttons/IconButton';
import { SearchInputProps } from '../MainHead';
import { PopupConfirmModal } from '../../modal/popup/PopupConfirmModal';

export const MarketPriceSearchInputSection = ({ searchInput }: { searchInput: SearchInputProps }) => {
  const [showEnterKeywordModal, setShowEnterKeywordModal] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleMarketPriceSearch = (searchKeyword: string) => {
    if (!searchKeyword) {
      setShowEnterKeywordModal(true);
      return;
    }

    ampli.pvmSearchMarketPrice({
      search_keyword: searchKeyword,
    });
    navigate(`${marketPricePageInfo.searchResultPage.path}?keyword=${searchKeyword}`, {
      replace: true,
    });
  };

  const onSearchKeywordChange = (newValue: string | number | undefined) => {
    if (newValue === undefined) {
      searchInput?.setSearchKeyword('');
      return;
    }

    searchInput?.setSearchKeyword(newValue as string);
  };

  return (
    <>
      <SearchInputBackground
        onSubmit={(event) => {
          event.preventDefault();
          handleMarketPriceSearch(searchInput.searchKeyword);
        }}
      >
        <NakedInput
          type={'text'}
          placeholder={'브랜드나 모델명을 입력하세요'}
          inputRef={searchInput.inputRef}
          onChange={onSearchKeywordChange}
          textAlign={'left'}
          isButton={searchInput.isResultPage}
          isEditable={!searchInput.isResultPage}
          onClick={() => {
            if (!searchInput.isResultPage) {
              return;
            }

            navigate(`${marketPricePageInfo.searchPage.path}?keyword=${searchInput.searchKeyword}`, {
              replace: true,
            });
          }}
        />
        <IconButton
          icon={{ name: 'CircleX', width: 20, height: 20, style: { fill: '#C6C6D5' } }}
          onClickEvent={() => {
            ampli.pvmClickGnbInputCancelButton({
              search_keyword: searchInput.searchKeyword,
            });
            if (!isIOS) {
              searchInput?.setSearchKeyword('');
              searchInput.inputRef.current?.blur();
              searchInput.inputRef.current?.focus();
            }
            navigate(marketPricePageInfo.searchPage.path, { replace: true });
          }}
        />
        <IconButton
          icon={{ name: 'Search', width: 20, height: 20, style: { fill: '#505363' } }}
          onClickEvent={() => handleMarketPriceSearch(searchInput.searchKeyword)}
        />
      </SearchInputBackground>

      <PopupConfirmModal
        isShow={showEnterKeywordModal}
        hasCloseButton={false}
        title={'검색어를 입력해 주세요'}
        buttonArray={[
          {
            text: '확인',
            onClick: () => setShowEnterKeywordModal(false),
            color: 'blue',
          },
        ]}
      />
    </>
  );
};

const SearchInputBackground = styled.form`
  height: 40px;

  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;

  padding: 8px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;
